var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__logo"},[_c('router-link',{attrs:{"to":{name:'Home'}}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/assets/images/logo.svg","alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }